module.exports = __webpack_public_path__ + "static/corezoid-oslo-open-api-2016-8f5419d4fa8ea7647c8566f002dd3b35.png";